ClickElseWhereMixin = require 'mixins/click-else-where'

###
# Мультиселект
###
App.SmMultiselectComponent = Em.Component.extend ClickElseWhereMixin,
  env: Em.inject.service('environment')

  classNames: [ 'sm-select' ]
  classNameBindings: [ 'isOpen' ]

  # Внутреннее состояние
  isOpen: false
  selection: Em.A([])

  # props
  labelPath:   '.name'
  idPath:      '.id'
  usePlainSelection: false

  placeholder: ''
  translationPlaceholder: 'sm_select.placeholder'

  label: (->
    selection    = @get('selection')
    placeholder  = @get('placeholder')
    translation  = @get('translationPlaceholder')
    labelPath    = @get('labelPath')

    count = 0
    count = selection.get('length') if Em.isArray(selection)

    if count is 0
      if Em.isEmpty(placeholder)
        @get('env').translate("#{translation}.zero")
      else
        placeholder
    else if count is 1 and not @get('usePlainSelection')
      selection.get("firstObject#{labelPath}")
    else
      @get('env').translate(translation, { count })
  ).property(
    'selection.[]',
    'labelPath',
    'placeholder',
    'translationPlaceholder')

  ###
  # Открытие/закрытие
  ###
  setClickInput: (->
    @$('.sm-select-value').on 'click', (e) =>
      @toggleProperty('isOpen')
      e.stopPropagation()
  ).on('didInsertElement')

  unsetClickInput: (->
    @$('.sm-select-value').off('click')
  ).on('willDestroyElement')

  onClickElsewhere: ->
    @set('isOpen', false)


###
# Элемент в списке селекта
###
App.SmMultiselectOptionComponent = Em.Component.extend
  classNames: [ 'sm-select-option' ]

  classNameBindings: [ 'selected' ]

  selected: (->
    selection = @get('parentView.selection')
    idPath    = @get('parentView.idPath')
    idItem    = @get("item#{idPath}")

    return unless selection

    found = selection.find (item) =>
      id = if Ember.isEmpty(idPath) then item else Ember.get(item, idPath[1..])
      id = item if @get('parentView.usePlainSelection')
      id is idItem

    found?
  ).property(
    'item',
    'parentView.idPath'
    'parentView.selection.[]')

  label: (->
    @get("item#{@get('parentView.labelPath')}")
  ).property('item', 'parentView.labelPath')

  click: ->
    return unless @get('parentView.isOpen')

    selection = @get('parentView.selection')
    item      = @get('item')
    idPath    = @get('parentView.idPath')
    idItem    = @get("item#{idPath}")

    found = selection.filter (item) =>
      id = if Ember.isEmpty(idPath) then item else Ember.get(item, idPath[1..])
      id = item if @get('parentView.usePlainSelection')
      id is idItem

    item = idItem if @get('parentView.usePlainSelection')

    if not Em.isEmpty(found)
      selection.removeObjects(found)
    else
      selection.pushObject(item)

    window.playgound = @get('parentView.selection')

